var qs = require('query-string');

function getRoutesList(world = 'de', i18n = { t: () => null }) {
    return {
        ABANDONED_CART_REDIRECT: {
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/abandoned-cart-redirect`,
            pathnames: {
                de: '/de/warenkorb-anschauen',
                es: '/es/mostrar-cesta-de-la-compra',
                fr: '/fr/voir-mon-panier',
                gr: '/gr/view-shopping-cart',
                it: '/it/vedi-il-carrello'
            }
        },

        AGRO_NORDWEST: {
            // DE-only
            meta: () => ({}),
            path: '/de/agro-nordwest'
        },

        AUTHORIZE: {
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/authorize`,
            pathnames: {
                de: '/de/authorize',
                es: '/es/authorize',
                fr: '/fr/authorize',
                gr: '/gr/authorize',
                it: '/it/authorize'
            }
        },
        AUTHOR_DOMAIN_BLOG: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/blog`,
            pathnames: {
                de: '/blog',
                es: '/blog',
                fr: '/blog',
                gr: '/blog',
                it: '/blog'
            }
        },
        AUTHOR_DOMAIN_MATERIALS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/materials`,
            pathnames: {
                de: '/materialien',
                es: '/materiales',
                fr: '/materiaux',
                gr: '/materials',
                it: '/materiali'
            }
        },
        AUTHOR_DOMAIN_MATERIAL_PAGE: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: '...'
            }),
            get path() {
                return `${this.prefix}/:id/:slug`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/material`,
            prefixes: {
                de: '/material',
                es: '/material',
                fr: '/material',
                gr: '/material',
                it: '/materiale'
            }
        },
        AUTHOR_MAIN: {
            meta() {
                const tabTitle = {
                    Blog: (author = {}) => {
                        // LMP instagram page
                        if (author.id === 620511 && world === 'de') {
                            return 'Instagram-Materialposts | eduki';
                        }

                        return i18n.t('meta:meta.AUTHOR_BLOG.title', { publicName: author.details.publicName });
                    },
                    Materials: (author = {}) =>
                        i18n.t('meta:meta.AUTHOR_MATERIALS.title', { publicName: author.details.publicName })
                };
                const tabDescription = {
                    Blog: (author = {}) => {
                        // LMP instagram page
                        if (author.id === 620511 && world === 'de') {
                            return 'Alle Links zu den Materialien von unserem eduki Instagram-Account ✅ Findet schnell & einfach alle Unterrichtsmaterialien auf einen Blick ✅';
                        }

                        return i18n.t('meta:meta.AUTHOR_BLOG.description', { publicName: author.details.publicName });
                    },
                    Materials: (author = {}) =>
                        i18n.t('meta:meta.AUTHOR_MATERIALS.description', {
                            publicName: author.details.publicName,
                            totalMaterials: author.details.totalMaterials
                        })
                };

                return {
                    description(author, tab) {
                        return tabDescription[tab]
                            ? tabDescription[tab](author)
                            : i18n.t('meta:meta.AUTHOR_MAIN.description', {
                                publicName: author.details.publicName,
                                totalMaterials: author.details.totalMaterials
                            });
                    },
                    title(author, tab) {
                        return tabTitle[tab]
                            ? tabTitle[tab](author)
                            : i18n.t('meta:meta.AUTHOR_MAIN.title', { publicName: author.details.publicName });
                    }
                };
            },
            get path() {
                return `${this.prefix}/:id/:slug`;
            },
            pathByWorld(segment = world) {
                const prefix = this.prefixes[segment] || this.defaultPrefix;

                return `${prefix}/:id/:slug`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/${world}/author`,
            prefixes: {
                de: '/de/autor',
                es: '/es/autor',
                fr: '/fr/auteur',
                gr: '/gr/author',
                it: '/it/autore'
            }
        },
        BLOGPOST: {
            meta: () => ({
                description(str) {
                    return str;
                },
                title(str) {
                    return str;
                }
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/post/:id`,
            pathnames: {
                de: '/de/post/:id',
                es: '/es/post/:id',
                fr: '/fr/billet/:id',
                gr: '/gr/post/:id',
                it: '/it/post/:id'
            }
        },
        BOUGHT_MATERIALS: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                title: i18n.t('meta:meta.DEFAULT.title'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                }
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/bought-materials`,
            pathnames: {
                de: '/de/erworbene-materialien',
                es: '/es/materiales-comprados',
                fr: '/fr/materiaux-achetes',
                gr: '/gr/purchased-materials',
                it: '/it/materiali-acquistati'
            },
            switchable: true
        },

        CABINET_BANK_DETAILS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/account-bank-details`,
            pathnames: {
                de: '/de/kontoverbindung',
                es: '/es/conexion-cuenta',
                fr: '/fr/connexion-compte',
                gr: '/gr/account-connection',
                it: '/it/coordinate-bancarie'
            },
            switchable: true
        },
        CABINET_CHANGE_EMAIL: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/cabinet-change-email`,
            pathnames: {
                de: '/de/email-aendern',
                es: '/es/cambiar-email',
                fr: '/fr/changer-email',
                gr: '/gr/change-email',
                it: '/it/modifica-email'
            },
            switchable: true
        },
        CABINET_CHANGE_PASSWORD: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/change-password`,
            pathnames: {
                de: '/de/passwort-aendern',
                es: '/es/cambiar-contrasena',
                fr: '/fr/changer-mot-passe',
                gr: '/gr/change-password',
                it: '/it/modifica-password'
            },
            switchable: true
        },
        CABINET_INVOICE_INFO: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/billing-address`,
            pathnames: {
                de: '/de/rechnungsanschrift',
                es: '/es/direccion-facturiacion',
                fr: '/fr/adresse-facturation',
                gr: '/gr/billing-address',
                it: '/it/indirizzo-fattura'
            },
            switchable: true
        },
        CABINET_PREFERENCE_CENTER: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/notifications`,
            pathnames: {
                de: '/de/benachrichtigungen',
                es: '/es/notificaciones',
                fr: '/fr/notifications',
                gr: '/gr/notifications',
                it: '/it/notifiche'
            },
            switchable: true
        },
        AGB: {
            meta: () => ({
                description: i18n.t('meta:meta.AGB.description'),
                image: '',
                keywords: '',
                title: i18n.t('meta:meta.AGB.title'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                }
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/info/terms-and-conditions`,
            pathnames: {
                de: '/de/info/agb',
                es: '/es/info/terminos-condiciones',
                fr: '/fr/info/modalites-conditions',
                gr: '/gr/info/terms-and-conditions',
                it: '/it/info/condizioni-generali'
            },
            switchable: true
        },
        GDPR_JOBS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/info/gdpr-jobs`,
            pathnames: {
                de: '/de/info/gdpr-jobs',
                es: '/es/info/gdpr-jobs',
                fr: '/fr/info/gdpr-jobs',
                gr: '/gr/info/gdpr-jobs',
                it: '/it/info/gdpr-jobs'
            },
        },
        IMPACT_PAGE: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/unser-impact-bildung`,
            pathnames: {
                de: '/de/unser-impact-bildung',
                es: '/es/unser-impact-bildung',
                fr: '/fr/unser-impact-bildung',
                gr: '/gr/unser-impact-bildung',
                it: '/it/unser-impact-bildung'
            },
        },
        CABINET_SALES: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/upload-edit`,
            pathnames: {
                de: '/de/hochladen-bearbeiten',
                es: '/es/subir-editar',
                fr: '/fr/telecharger-editer',
                gr: '/gr/upload-edit',
                it: '/it/carica-modifica'
            },
            switchable: true
        },
        API: {
            meta: () => ({
                description: i18n.t('meta:meta.API.description'),
                image: '',
                keywords: '',
                title: i18n.t('meta:meta.API.title'),
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                }
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/api`,
            pathnames: {
                de: '/de/api',
                es: '/es/api',
                fr: '/fr/api',
                gr: '/gr/api',
                it: '/it/api'
            }
        },
        CABINET_UPLOAD: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/first-upload/:materialId?`,
            pathnames: {
                de: '/de/erster-upload/:materialId?',
                es: '/es/carga-inicial/:materialId?',
                fr: '/fr/telechargement-initial/:materialId?',
                gr: '/gr/first-upload/:materialId?',
                it: '/it/primo-upload/:materialId?'
            }
        },
        CHANGE_COUNTRY: {
            get path() {
                return this.pathnames[world]  || this.defaultPath;
            },
            defaultPath: `/${world}/change-country`,
            pathnames: {
                de: '/de/andern-land',
                es: '/es/change-riik',
                fr: '/fr/changer-de-pays',
                gr: '/gr/change-country',
                it: '/it/cambiare-paese'
            }
        },
        CHANGE_EMAIL_CONFIRM: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/change-email/confirm/:confirmationToken`,
            pathnames: {
                de: '/de/email-aendern/bestaetigen/:confirmationToken',
                es: '/es/cambiar-email/confirmar/:confirmationToken',
                fr: '/fr/changer-email/confirmer/:confirmationToken',
                gr: '/gr/change-email/confirm/:confirmationToken',
                it: '/it/modifica-email/conferma/:confirmationToken'
            }
        },
        CHARTS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/evaluation`,
            pathnames: {
                de: '/de/auswertung',
                es: '/es/evaluacion',
                fr: '/fr/evaluation',
                gr: '/gr/evaluation',
                it: '/it/analisi'
            },
            switchable: true
        },
        CLIMATE_ACTION: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/climate-change-act-now`,
            pathnames: {
                de: '/de/klimawandel-jetzt-handeln',
                es: '/es/cambio-climatico-actua-ahora',
                fr: '/fr/rechauffement-climatique-agir-maintenant',
                gr: '/gr/climate-change-act-now',
                it: '/it/cambiamento-climatico-agire-ora'
            }
        },
        AUTHOR_UNSUBSCRIBE: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            path: '/:world/unfollow-author/:token'
        },
        CREATE_BLOGPOST: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/post-editor`,
            pathnames: {
                de: '/de/post-editor',
                es: '/es/post-editor',
                fr: '/fr/billet-editeur',
                gr: '/gr/post-editor',
                it: '/it/post-editor'
            }
        },
        AUTHOR_REDIRECT: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/my-author-profile`,
            pathnames: {
                de: '/de/mein-autorenprofil',
                es: '/es/perfil-autor',
                fr: '/fr/profil-auteur',
                gr: '/gr/my-author-profile',
                it: '/it/mio-profilo-autore'
            }
        },
        CREDITS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/credit`,
            pathnames: {
                de: '/de/guthaben',
                es: '/es/saldo',
                fr: '/fr/solde-crediteur',
                gr: '/gr/credit',
                it: '/it/crediti'
            },
            switchable: true
        },
        BUILDER_PREVIEW: {
            // DE-only
            meta: () => ({}),
            path: '/de/builder-preview'
        },
        CREDIT_NOTES: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/fee`,
            pathnames: {
                de: '/de/honorar',
                es: '/es/regalias',
                fr: '/fr/royautes',
                gr: '/gr/fee',
                it: '/it/compenso'
            },
            switchable: true
        },
        DONATE_UKRAINE: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/saveukraine`,
            pathnames: {
                de: '/de/saveukraine',
                es: '/es/saveukraine',
                fr: '/fr/saveukraine',
                gr: '/gr/saveukraine',
                it: '/it/saveukraine'
            }
        },
        ENTRY_POINT: {
            meta: () => ({
                auto: {
                    ograph: true
                },
                description: 'eduki',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: 'eduki'
            }),
            path: '/'
        },
        FAQ: {
            meta: () => ({
                description: i18n.t('meta:meta.FAQ.description'),
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.FAQ.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/info/questions`,
            pathnames: {
                de: '/de/info/fragen',
                es: '/es/info/preguntas-frequentes',
                fr: '/fr/info/questions-frequentes',
                gr: '/gr/info/questions',
                it: '/it/info/domande'
            },
            switchable: true
        },
        FAVORITES: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/favourites`,
            pathnames: {
                de: '/de/merkzettel',
                es: '/es/favoritos',
                fr: '/fr/favoris',
                gr: '/gr/favourites',
                it: '/it/miei-preferiti'
            }
        },
        FILL_PERSONALIZATION_REDIRECT: {
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/my-subjects`,
            pathnames: {
                de: '/de/meine-faecher',
                es: '/es/mis-asignaturas',
                fr: '/fr/mes-matieres',
                gr: '/gr/my-subjects',
                it: '/it/le-mie-materie'
            }
        },

        FINISH_REGISTRATION: {
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/complete-registration/:token`,
            pathnames: {
                de: '/de/registrierung-abschliessen/:token',
                es: '/es/registro-completado/:token',
                fr: '/fr/inscription-reussie/:token',
                gr: '/gr/complete-registration/:token',
                it: '/it/registrazione-completata/:token'
            }
        },

        FONTS: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/tools`,
            pathnames: {
                de: '/de/werkzeuge',
                es: '/es/herramientas',
                fr: '/fr/outils',
                gr: '/gr/tools',
                it: '/it/strumenti'
            }
        },

        FORGOT_PASSWORD: {
            meta: () => ({
                description: i18n.t('meta:meta.FORGOT_PASSWORD.description'),
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.FORGOT_PASSWORD.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/forgot-password`,
            pathnames: {
                de: '/de/passwort-vergessen',
                es: '/es/contrasena-olvidada',
                fr: '/fr/mot-passe-oublie',
                gr: '/gr/forgot-password',
                it: '/it/password-dimenticata'
            }
        },

        // .de only
        FOUNDATION: {
            meta: () => ({
                description: i18n.t('meta:meta.FOUNDATION.description'),
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.FOUNDATION.title')
            }),
            path: '/:world/stiftung-guter-unterricht'
        },

        FREE_DOWNLOAD: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            path: '/:world/free-material-download/:token'
        },

        FREE_MATERIALS_LANDING: {
            meta: () => ({
                description: i18n.t('meta:meta.FREE_MATERIALS_LANDING.description'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.FREE_MATERIALS_LANDING.title')
            }),
            path: '/de/stiftung/unterrichtsmaterial'
        },

        HELP_CENTER: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/help`,
            pathnames: {
                de: '/de/hilfe',
                es: '/es/ayuda',
                fr: '/fr/aide',
                gr: '/gr/help',
                it: '/it/aiuto'
            },
            switchable: true
        },

        HOME: {
            meta: () => ({
                auto: {
                    ograph: true
                },
                description: i18n.t('meta:meta.HOME.description'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.HOME.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}`,
            pathnames: {
                de: '/de',
                es: '/es',
                fr: '/fr',
                gr: '/gr',
                it: '/it'
            }
        },

        HOME_SCHOOLING: {
            meta: () => ({
                auto: {
                    ograph: true
                },
                description: i18n.t('meta:meta.HOME_SCHOOLING.description'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.HOME_SCHOOLING.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/homeschooling`,
            pathnames: {
                de: '/de/homeschooling',
                es: '/es/homeschooling',
                fr: '/fr/homeschooling',
                gr: '/gr/homeschooling',
                it: '/it/homeschooling'
            }
        },

        IMPRESSUM: {
            meta: () => ({
                description: i18n.t('meta:meta.IMPRESSUM.description'),
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.IMPRESSUM.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/imprint`,
            pathnames: {
                de: '/de/info/impressum',
                es: '/es/info/imprimir',
                fr: '/fr/info/mentions-legales',
                gr: '/gr/info/imprint',
                it: '/it/info/note-legali'
            },
            switchable: true
        },

        INCLUSION_CAMPAIGN: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/inclusive-lessons`,
            pathnames: {
                de: '/de/inklusiver-unterricht',
                es: '/es/inclusion-en-el-aula',
                fr: '/fr/inclusion-scolaire',
                gr: '/gr/inclusive-lessons',
                it: '/it/insegnamento-inclusivo'
            }
        },

        INTERACTIVE_MAIN_LANDING: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/interactive`,
            pathnames: {
                de: '/de/interactive',
                es: '/es/interactive',
                fr: '/fr/interactive',
                gr: '/gr/interactive',
                it: '/it/interactive'
            }
        },

        NEW_INTERACTIVE_MAIN: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/interactive`,
            pathnames: {
                de: '/de/interactive',
                es: '/es/interactive',
                fr: '/fr/interactive',
                gr: '/gr/interactive',
                it: '/it/interactive'
            }
        },

        NEW_INTERACTIVE_HOME: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/interactive/home`,
            pathnames: {
                de: '/de/interactive/startseite',
                es: '/es/interactive/home',
                fr: '/fr/interactive/home',
                gr: '/gr/interactive/home',
                it: '/it/interactive/home'
            }
        },

        NEW_INTERACTIVE_MATERIALS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/interactive/materials`,
            pathnames: {
                de: '/de/interactive/entdecken',
                es: '/es/interactive/materials',
                fr: '/fr/interactive/materials',
                gr: '/gr/interactive/materials',
                it: '/it/interactive/materials'
            }
        },

        NEW_INTERACTIVE_MY_MATERIALS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/interactive/my-interactives`,
            pathnames: {
                de: '/de/interactive/meine-interactives',
                es: '/es/interactive/my-interactives',
                fr: '/fr/interactive/my-interactives',
                gr: '/gr/interactive/my-interactives',
                it: '/it/interactive/my-interactives'
            }
        },

        NEW_INTERACTIVE_ROOMS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/interactive/learning-rooms`,
            pathnames: {
                de: '/de/interactive/alle-ergebnisse',
                es: '/es/interactive/learning-rooms',
                fr: '/fr/interactive/learning-rooms',
                gr: '/gr/interactive/learning-rooms',
                it: '/it/interactive/learning-rooms'
            }
        },

        NEW_INTERACTIVE_COURSES: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/interactive/courses`,
            pathnames: {
                de: '/de/interactive/kurse',
                es: '/es/interactive/courses',
                fr: '/fr/interactive/courses',
                gr: '/gr/interactive/courses',
                it: '/it/interactive/courses'
            }
        },

        INVOICES_AND_TAXES: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/invoice-tax-documents`,
            pathnames: {
                de: '/de/rechnungen-steuerbelege',
                es: '/es/facturas',
                fr: '/fr/factures',
                gr: '/gr/invoices-tax-documents',
                it: '/it/fatture-ricevute-fiscali'
            },
            switchable: true
        },

        JOBS: {
            meta: () => ({}),
            path: '/jobs'
        },

        KEYWORD_LANDING: {
            meta: () => ({
                description: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return `${this.prefix}/:id/:slug*`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/${world}/tema`,
            prefixes: {
                de: '/de/tema',
                es: '/es/tema',
                fr: '/fr/tema',
                gr: '/gr/tema',
                it: '/it/tema'
            }
        },

        LANDING: {
            meta: () => ({
                description: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return `${this.prefix}/:id/:slug*`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/${world}/lessons`,
            prefixes: {
                de: '/de/unterricht',
                es: '/es/temas',
                fr: '/fr/sujets',
                gr: '/gr/lessons',
                it: '/it/lezione'
            }
        },

        SCHOOL_LANDING_PAGES: {
            meta: () => ({
                description: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get fullpath() {
                return `${this.prefix}/:school/:id/:slug*`;
            },
            get path() {
                return `${this.prefix}/:school`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/${world}/schools`,
            prefixes: {
                de: '/de/schulmaterialen',
            }
        },

        LMP_HISTORY: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/lehrermarktplatz`,
            pathnames: {
                de: '/de/lehrermarktplatz',
                es: '/es/lehrermarktplatz',
                fr: '/fr/lehrermarktplatz',
                gr: '/gr/lehrermarktplatz',
                it: '/it/lehrermarktplatz'
            }
        },

        LOGIN: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/login`,
            pathnames: {
                de: '/de/anmelden',
                es: '/es/entra',
                fr: '/fr/connecter',
                gr: '/gr/login',
                it: '/it/login'
            },
            switchable: true
        },

        LOGIN_AS: {
            meta: () => ({}),
            path: '/:world/login-as'
        },

        MAGAZINE: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/magazine`,
            pathnames: {
                de: '/de/magazin',
                es: '/es/magazine',
                fr: '/fr/magazine',
                gr: '/gr/magazine',
                it: '/it/rivista'
            }
        },

        // single url for all domains
        MAILING_UNSUBSCRIBE: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            path: '/:world/mailing-unsubscribe/:token'
        },

        UNSUBSCRIBE_BY_LINK: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            path: '/:world/unsubscribe-by-link'
        },

        MATERIAL: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: '...'
            }),
            get path() {
                return `${this.prefix}/:id/:slug`;
            },
            pathByWorld(segment = world) {
                const prefix = this.prefixes[segment] || this.defaultPrefix;

                return `${prefix}/:id/:slug`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/${world}/material`,
            prefixes: {
                de: '/de/material',
                es: '/es/material',
                fr: '/fr/material',
                gr: '/gr/material',
                it: '/it/materiale'
            }
        },

        MATERIAL_CARD_PREVIEW: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/material-card-preview/:id`,
            pathnames: {
                de: '/de/material-card-preview/:id',
                es: '/es/material-card-preview/:id',
                fr: '/fr/material-card-preview/:id',
                gr: '/gr/material-card-preview/:id',
                it: '/it/material-card-preview/:id'
            }
        },

        MATERIAL_FEEDBACK: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/material-feedback/:id`,
            pathnames: {
                de: '/de/material-feedback/:id',
                es: '/es/material-feedback/:id',
                fr: '/fr/material-feedback/:id',
                gr: '/gr/material-feedback/:id',
                it: '/it/material-feedback/:id'
            }
        },

        MENTAL_HEALTH_KIDS_LANDING: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/are-you-ok/kids`,
            pathnames: {
                de: '/de/are-you-ok/kids',
                es: '/es/are-you-ok/estudiantes',
                fr: '/fr/are-you-ok/eleves',
                gr: '/gr/are-you-ok/kids',
                it: '/it/stai-bene/bambini'
            }
        },

        MENTAL_HEALTH_LANDING: {
            meta: () => ({
                description: i18n.t('meta:meta.MENTAL_HEALTH_LANDING.description'),
                title: i18n.t('meta:meta.MENTAL_HEALTH_LANDING.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/are-you-ok`,
            pathnames: {
                de: '/de/are-you-ok',
                es: '/es/are-you-ok',
                fr: '/fr/are-you-ok',
                gr: '/gr/are-you-ok',
                it: '/it/stai-bene'
            }
        },

        MICROSOFT_REDIRECT_URI: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/microsoft-redirect-uri`,
            pathnames: {
                de: '/de/microsoft-redirect-uri',
                es: '/es/microsoft-redirect-uri',
                fr: '/fr/microsoft-redirect-uri',
                gr: '/gr/microsoft-redirect-uri',
                it: '/it/microsoft-redirect-uri'
            }
        },

        MOBILE_APP_LANDING: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/app`,
            pathnames: {
                de: '/de/app',
                es: '/es/app',
                fr: '/fr/app',
                gr: '/gr/app',
                it: '/it/app'
            }
        },

        MY_SALES: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/sales-downloads`,
            pathnames: {
                de: '/de/verkaeufe-downloads',
                es: '/es/materials-vendidos',
                fr: '/fr/ressources-vendues',
                gr: '/gr/sales-downloads',
                it: '/it/vendite-download'
            },
            switchable: true
        },

        NPS: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/nps`,
            pathnames: {
                de: '/de/nps',
                es: '/es/satisfaccion',
                fr: '/fr/satisfaction',
                gr: '/gr/nps',
                it: '/it/nps'
            }
        },

        OUR_TEAM: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/team-${world}`,
            pathnames: {
                de: '/de/team-de',
                es: '/es/team-es',
                fr: '/fr/team-fr',
                gr: '/gr/team-gr',
                it: '/it/team-it'
            }
        },

        PARTNERS: {
            meta: () => ({
                description: i18n.t('meta:meta.PARTNERS.description'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.PARTNERS.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/partners`,
            pathnames: {
                de: '/de/partner',
                es: '/es/colaboradores',
                fr: '/fr/partenaires',
                gr: '/gr/partners',
                it: '/it/partner'
            }
        },

        PASSWORD_RECOVERY: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/password-recovery/:token`,
            pathnames: {
                de: '/de/password-recovery/:token',
                es: '/es/recuperar-contrasena/:token',
                fr: '/fr/recuperer-mot-passe/:token',
                gr: '/gr/password-recovery/:token',
                it: '/it/recupero-password/:token'
            }
        },

        PAYMENT: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/payment`,
            pathnames: {
                de: '/de/zahlung',
                es: '/es/pago',
                fr: '/fr/paiement',
                gr: '/gr/payment',
                it: '/it/pagamento'
            }
        },

        PODCASTS: {
            meta: () => ({
                auto: {
                    ograph: true
                },
                description: i18n.t('meta:meta.PODCASTS.description'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.PODCASTS.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/podcast`,
            pathnames: {
                de: '/de/marktplatzplauderei-podcast',
                es: '/es/podcast',
                fr: '/fr/podcast',
                gr: '/gr/marktplatzchaterei-podcast',
                it: '/it/podcast-chiacchiere-del-mercato'
            }
        },

        RATING_EMAIL_LANDING: {
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/rating-email-landing`,
            pathnames: {
                de: '/de/rating-email-landing',
                es: '/es/rating-email-iniciar',
                fr: '/fr/evaluation-debut',
                gr: '/gr/rating-email-landing',
                it: '/it/landing-email-valutazione'
            }
        },

        RECOMMENDATION: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            path: '/:world/recommendation/:token'
        },

        REFERRAL_INCENTIVE_LANDING: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/invitation`,
            pathnames: {
                de: '/de/invitacion',
                es: '/es/invitacion',
                fr: '/fr/invitation',
                gr: '/gr/invitation',
                it: '/it/invito'
            }
        },

        REFERRAL_INCENTIVE_LANDING_FOR_UNAUTHORIZED: {
            // ES-only
            meta: () => ({}),
            path: '/es/invita-docentes'
        },

        RUSSIA_ATTACKS_UKRAINE_LANDING: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/standwithukraine`,
            pathnames: {
                de: '/de/unterrichtsmaterial-krieg-ukraine',
                es: '/es/standwithukraine',
                fr: '/fr/standwithukraine',
                gr: '/gr/educational-material-war-ukraine',
                it: '/it/insegnamento-inclusivo-guerra-ucraina'
            }
        },

        RUSSIA_ATTACKS_UKRAINE_LANDING_BACKUP: {
            // DE-only
            meta: () => ({}),
            path: '/de/standwithukraine'
        },

        SEARCH_RESULT: {
            defaultPath: `/${world}/search-results`,
            pathnames: {
                de: '/de/suchergebnisse',
                es: '/es/resultados-busqueda',
                fr: '/fr/resultats-recherche',
                it: '/it/risultati-della-ricerca',
                gr: '/gr/search-results'
            },
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            meta: () => ({})
        },

        SALE_LANDING: {
            meta: () => ({
                description: i18n.t('meta:meta.SALE_LANDING.description'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.SALE_LANDING.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/offers`,
            pathnames: {
                de: '/de/angebote',
                es: '/es/ofertas',
                fr: '/fr/soldes',
                gr: '/gr/offers',
                it: '/it/offerte'
            }
        },

        SEASONAL_MATERIALS_LANDING: {
            meta: () => ({
                description: i18n.t('meta:meta.SEASONAL_MATERIALS_LANDING.description'),
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.SEASONAL_MATERIALS_LANDING.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/recommendations`,
            pathnames: {
                de: '/de/empfehlungen',
                es: '/es/recomendaciones',
                fr: '/fr/recommandations',
                gr: '/gr/recommendations',
                it: '/it/raccomandazioni'
            }
        },
        MY_SCHOOL: {
            pathnames: {
                de: '/de/meine-schule',
                es: '/es/mi-escuela',
                fr: '/fr/mon-ecole',
                gr: '/gr/my-school',
                it: '/it/my-school'
            },
            defaultPath: `/${world}/my-school`,
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            meta: () => ({
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                }
            })
        },
        SCHOOL_WISHLIST: {
            pathnames: {
                de: '/de/schulmerkzettel',
                es: '/es/notas-escolares',
                fr: '/fr/notes-decole',
                gr: '/gr/school-wishlist',
                it: '/it/school-wishlist'
            },
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/school-wishlist`,
            meta: () => ({
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
            })
        },
        SELLER: {
            meta: () => ({
                description: i18n.t('meta:meta.SELLER.description'),
                robots: 'all',
                title: i18n.t('meta:meta.SELLER.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/material-sharing`,
            pathnames: {
                de: '/de/material-teilen',
                es: '/es/compartir-material',
                fr: '/fr/partager-materiel',
                gr: '/gr/material-sharing',
                it: '/it/condividi-materiale'
            },
            switchable: true
        },

        SIGN_UP: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/register`,
            pathnames: {
                de: '/de/registrieren',
                es: '/es/registrate',
                fr: '/fr/inscrire',
                gr: '/gr/register',
                it: '/it/registrazione'
            },
            switchable: true
        },

        SIGN_UP_CONFIRM: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/register/confirm/:registrationToken`,
            pathnames: {
                de: '/de/registrieren/bestatigen/:registrationToken',
                es: '/es/registrate/confirmar/:registrationToken',
                fr: '/fr/inscrire/confirmer/:registrationToken',
                gr: '/gr/register/confirm/:registrationToken',
                it: '/it/registrazione/conferma/:registrationToken'
            }
        },

        STEPS_HOCHLADEN: {
            meta: () => ({
                description: i18n.t('meta:meta.STEPS_HOCHLADEN.description'),
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.STEPS_HOCHLADEN.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/step-upload`,
            pathnames: {
                de: '/de/schritt-hochladen',
                es: '/es/paso-subir',
                fr: '/fr/etape-telecharger',
                gr: '/gr/step-upload',
                it: '/it/fase-caricamento'
            },
            switchable: true
        },

        STEPS_NAME: {
            meta: () => ({
                description: i18n.t('meta:meta.STEPS_NAME.description'),
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.STEPS_NAME.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/step-name`,
            pathnames: {
                de: '/de/schritt-name',
                es: '/es/paso-name',
                fr: '/fr/etape-nom',
                gr: '/gr/step-name',
                it: '/it/fase-nome'
            }
        },

        STIFTUNG_LANDING: {
            meta: () => ({
                description: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            path: '/de/stiftung/unterrichtsmaterial/:id/:slug*'
        },

        SCHOOL_ACCOUNT: {
            pathnames: {
                de: '/de/schulaccount',
                es: '/es/cuentaescolar',
                fr: '/fr/schoolaccount',
                it: '/it/schoolaccount',
                gr: '/gr/schoolaccount'
            },
            defaultPath: `/${world}/schoolaccount`,
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            meta: () => ({})
        },
        SCHOOL_CREATE: {
            pathnames: {
                de: '/de/schuleerstellen',
                es: '/es/schuleerstellen',
                fr: '/fr/schuleerstellen',
                it: '/it/schuleerstellen',
                gr: '/gr/schuleerstellen'
            },
            defaultPath: `/${world}/school-create`,
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            meta: () => ({})
        },
        TEILEN: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/share`,
            pathnames: {
                de: '/de/teilen',
                es: '/es/compartir',
                fr: '/fr/partager',
                gr: '/gr/share',
                it: '/it/condividi'
            },
            switchable: true
        },

        THANK_YOU_PAGE: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/order-confirmation`,
            pathnames: {
                de: '/de/bestellbesteatigung',
                es: '/es/confirmacion-orden',
                fr: '/fr/confirmation-commande',
                gr: '/gr/order-confirmation',
                it: '/it/conferma-ordine'
            }
        },

        THANK_YOU_PAGE_INVOICE: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'all'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/invoice-purchase-success`,
            pathnames: {
                de: '/de/invoice-purchase-success',
                es: '/es/compra-cuenta-exitosa',
                fr: '/fr/achat-compte-succes',
                gr: '/gr/invoice-purchase-success',
                it: '/it/fattura-avvenuto-acquisto'
            }
        },

        // single url for all domains
        UNSUBSCRIBE: {
            meta: () => ({
                description: '',
                image: '',
                keywords: '',
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                },
                title: i18n.t('meta:meta.DEFAULT.title')
            }),
            path: '/:world/unsubscribe/:token'
        },

        USER_PROFILE: {
            meta: () => ({
                description: (author) =>
                    i18n.t('meta:meta.USER_PROFILE.description', { publicName: author.details.publicName }),
                title: (author) => i18n.t('meta:meta.USER_PROFILE.title', { publicName: author.details.publicName })
            }),
            get path() {
                return `${this.prefix}/:id/:slug`;
            },
            pathByWorld(segment = world) {
                const prefix = this.prefixes[segment] || this.defaultPrefix;

                return `${prefix}/:id/:slug`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/${world}/id`,
            prefixes: {
                de: '/de/id',
                es: '/es/id',
                fr: '/fr/id',
                gr: '/gr/id',
                it: '/it/id'
            }
        },

        USER_PROFILE_NO_SLUG: {
            meta: () => ({
                description: (author) =>
                    i18n.t('meta:meta.USER_PROFILE.description', { publicName: author.details.publicName }),
                title: (author) => i18n.t('meta:meta.USER_PROFILE.title', { publicName: author.details.publicName })
            }),
            get path() {
                return `${this.prefix}/:id`;
            },
            pathByWorld(segment = world) {
                const prefix = this.prefixes[segment] || this.defaultPrefix;

                return `${prefix}/:id/:slug`;
            },
            get prefix() {
                return this.prefixes[world] || this.defaultPrefix;
            },
            defaultPrefix: `/${world}/id`,
            prefixes: {
                de: '/de/id',
                es: '/es/id',
                fr: '/fr/id',
                gr: '/gr/id',
                it: '/it/id'
            }
        },

        VOUCHERS: {
            meta: () => ({}),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/vouchers`,
            pathnames: {
                de: '/de/gutscheine',
                es: '/es/vales',
                fr: '/fr/coupons',
                gr: '/gr/vouchers',
                it: '/it/buoni'
            },
            switchable: true
        },

        WARENKORB: {
            meta: () => ({
                meta: {
                    name: {
                        robots: 'noindex,follow'
                    }
                }
            }),
            get path() {
                return this.pathnames[world] || this.defaultPath;
            },
            defaultPath: `/${world}/shopping-cart`,
            pathnames: {
                de: '/de/warenkorb',
                es: '/es/carro-compra',
                fr: '/fr/panier-achat',
                gr: '/gr/shopping-cart',
                it: '/it/carrello'
            }
        }
    };
}

function makeUrl(url = '', pathParams = {}, queryParams) {
    Object.keys(pathParams).forEach((k) => {
        url = url.replace(`:${k}`, pathParams[k]).replace('*', '').replace('?', '');
    });

    if (queryParams) {
        url = `${url}?${qs.stringify(queryParams)}`;
    }

    return url;
}

module.exports = {
    getRoutesList,
    makeUrl
};
